import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext';
import DiscoverPsyPage from './DiscoverPsychPage';

export default WithGASetup(DiscoverPsyPage, AuthContext);
